class SportsbookTransactionRecord {
  id;
  ticketId;
  betAmount;
  betCoupon;
  ticketStatus;
  sabaTicketId;
  compUserId;
  betType;
  currency;
  betTime;
  ip;
  settleAmount;
  winloseCoupon;
  settleResult;
  settleTime;
  options;
  bets;
  created_at;
  updated_at;
}
var TicketStatus = /* @__PURE__ */ ((TicketStatus2) => {
  TicketStatus2["Unknown"] = "Unknown";
  TicketStatus2["Awaiting"] = "Awaiting";
  TicketStatus2["Rejected"] = "Rejected";
  TicketStatus2["Accepted"] = "Accepted";
  TicketStatus2["Voided"] = "Voided";
  TicketStatus2["Settled"] = "Settled";
  TicketStatus2["Canceled"] = "Canceled";
  return TicketStatus2;
})(TicketStatus || {});
export {
  SportsbookTransactionRecord,
  TicketStatus
};
//# sourceMappingURL=type.js.map
